import { useMemo, useState } from 'react';
import { useTrivia, useUser } from '../../../../hooks';
import { downloadReportTrivia } from '../../../../helpers';
import { generateTriviaPDF } from '../../../../helpers/triviaReportPDF';
import { usePublication } from '../../../../hooks/usePublication';

export const ModalTriviaActions = () => {
  const { activeQuestion, validateTrivia, result, changeQuestion, questions } = useTrivia();
  const [isDownloadFile, setIsDownloadFile] = useState(false);
  const isFinishQuestion = useMemo(() => {
    const currentQuestion = questions.findIndex( question => question.id === activeQuestion?.id) + 1;  
    return currentQuestion === questions.length;
}, [activeQuestion, questions])
  const {publication } = usePublication()
  const { timeElapsed, attempt, retryTrivia } = useTrivia();

const { user } = useUser();
  /**
   * Valida la trivia
   */
  const onValidateTrivia = () =>{
    validateTrivia();
  }

  /**
   * Permite descargar el reporte del resultado final de la trivia
   */
  const downloadReport = async () => {
    setIsDownloadFile(true);
    const correctas = result?.filter(item => item.ok === true).length || 0;
    const finalResult = questions.map(q => {
        const r = result?.find(r => r.question?.id === q.id);

            return {
                ok: r?.ok ?? false,
                question: q,
                optionSelect: r?.optionSelect,
                optionCorrect: r?.optionCorrect
            };
    });
    generateTriviaPDF({
         triviaTitle: publication?.title || "Trivia sin título",
         playDate: new Date().toLocaleDateString(),
         userName: user?.sus_nombre || "Anónimo",
         userEmail: user?.sus_email || "",
         totalHits: correctas,
         total: result?.length || 0,
         percent: (correctas / (result?.length || 1)) * 100 || 0,
         timeElapsed,
         result: finalResult || [],
         attempt
     })
    /* await downloadReportTrivia({ idContainer: 'table-report-trivia', usuario: user?.sus_nombre}); */
    setIsDownloadFile(false);
  }

  /**
   * Cambia la pregunta basado en el indice
   * @param questionIndex Indice de la pregunta que se desea cambiar
   */
  const handleChangeQuestion = (questionIndex: number) =>{
    const question = questions[questionIndex];

    if(!question) return;

    changeQuestion(question);
  }

  /**
   * Permite continuar a la siguiente pregunta
   */
  const nextQuestion = () => {
    const nextQuestion = questions.findIndex( question => question.id === activeQuestion?.id) + 1;

    if(!nextQuestion || nextQuestion >= questions.length ) return;

    handleChangeQuestion(nextQuestion);
  }

  /**
   * Permite cambiar a la anterior pregunta
   */
  const previousQuestion = () =>{
    const nextQuestion = questions.findIndex( question => question.id === activeQuestion?.id) - 1;

    if(nextQuestion < 0 ) return;

    handleChangeQuestion(nextQuestion);
  }

  return (
    <div className="modal__actions">
        {
            (!result) && (
                <button type="button" className="btn btn-alt-primary" onClick={previousQuestion}>
                    <span className="btn__label">Anterior</span>
                </button>
            )
        }
        {
            (!result && !isFinishQuestion) && (
                <button type="button" className="btn btn-alt-primary btn-alt-primary--red" onClick={nextQuestion}>
                    <span className="btn__label">Siguiente</span>
                </button>
            )
        }
        {
            (activeQuestion && !result && isFinishQuestion) && (
                <button type="button" className="btn btn-alt-primary btn-alt-primary--red" onClick={onValidateTrivia}>
                    <span className="btn__label">Validar</span>
                </button>
            )
        }
        {
            (result) && (
                <>
                    <button
                    type="button"
                    className="btn btn-alt-primary"
                    onClick={retryTrivia}
                    >
                    <span className="btn__label">Reintentar</span>
                    </button>

                    <button
                    type="button"
                    className="btn btn-alt-primary btn-alt-primary--red"
                    onClick={downloadReport}
                    >
                    <span className="btn__label">Descargar reporte</span>
                    </button>
                </>
            )
        }
    </div>
  )
}